import { formatUser, type User } from '@halo/chat-sdk';
import type { StateCreatorEnhance } from '@halo/zustand-enhance';
import type { AppStore } from '../main';

export interface InitUserOptions {
  userId: string;
  deviceId: string;
}

export interface UserStore {
  user: User;
  deviceId: string;
  initUser: (options: InitUserOptions) => Promise<void>;
  setUser: (user: User) => void;
  updateUser: (user: Partial<User>) => void;
  getUserInfo: (userId: string) => Promise<{
    promise: Promise<void>;
    removeListener: () => void;
  }>;
  getUserProfiles: (
    userId: string,
    cb?: (data: User) => void
  ) => Promise<{
    promise: Promise<void>;
    removeListener: () => void;
  }>;
}

export const userStoreCreator: StateCreatorEnhance<AppStore> = (set, get) =>
  ({
    initUser: async (options) => {
      const { getUserProfiles, updateUser, getUserInfo } = get();
      set({ deviceId: options.deviceId });
      getUserInfo(options.userId); // fix concat user info
      const result = await getUserProfiles(options.userId, updateUser);
      await result.promise;
    },
    updateUser: (user) => {
      const { user: currentUser } = get();
      set({
        user: formatUser({
          ...currentUser,
          ...user,
        }),
      });
    },
    getUserProfiles: async (userId, cb) => {
      const { client, updateUser } = get();
      const userProps = await client?.Api.user.getUserProps();

      const result = client?.Api.user.getUserProfiles(userId, (user) => {
        const newUser = {
          ...user,
          ...userProps,
        };
        cb?.(newUser);
        updateUser(newUser);
      });

      return result;
    },
    getUserInfo: async (userId) => {
      const { client } = get();
      const result = client?.Api.user.resolveUsersInfo(userId, (user) => {
        return user;
      });
      return result;
    },
  }) as AppStore;
